import { useQuery } from "@tanstack/react-query";
import { get } from "../components/utils/request";
import { useAuthStore } from "../stores/authStore";

const fetchTokensData = async ({ token }) => {
  const response = await get({
    path: "/auth/data-user-transaction",
    token,
  });
  return response;
};

export const useTransactionFiat = () => {
  const { auth } = useAuthStore();

  const transactionFiatQuery = useQuery({
    queryKey: ["transactionFiat"],
    queryFn: () => fetchTokensData({ token: auth.accessToken }),
    refetchInterval: 1000 * 60 * 5,
    enabled: !!auth.accessToken,
  });

  return {
    transactionFiatQuery,
  };
};
